import React, { useState, useCallback } from 'react';
import Code from '../../Code/Code';
import EmbedCodeCopyButton from '../../EmbedCodeCopyButton/EmbedCodeCopyButton';
import ComboBox from '../../../../components/ComboBox/ComboBox';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';
import getBaseUrl from '../../../../../services/mini/getBaseUrl';
import getHostUrlForIntegrations from '../../../../../services/mini/getHostUrlForIntegrations';

const alanNodeCode = '<div class="alan-btn"></div>';
const googleFontCode = '<link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">';


function getAlanScriptCode(key, alanLibUrl, codeMode) {
    return '<script type="text/javascript"\n ' +
        `src="${alanLibUrl}"></script>\n` +
        '<script>\n' +
        '  var alanBtnInstance = alanBtn({\n' +
        '    key: "' + key + '\",\n' +
        '    host: "' + getHostUrlForIntegrations() + '\",\n' +
        (codeMode === 'simple' ? '' :
            '    authData: {data:"your auth data if needed"},\n') +
        '    onCommand: function (commandData) {\n' +
        '      if (commandData.command === "go:back") {\n' +
        '        //call client code that will react on the received command\n' +
        '      }\n' +
        '    },\n' +
        '    rootEl: document.getElementById("alan-btn"),\n' +
        '  });\n' +
        (codeMode === 'simple' ? '' :
            ('  //this is how you can set up a visual state\n' +
                '  alanBtnInstance.setVisualState({data:"your data"});\n' +
                '\n' +
                '  //this is how you can call projectAPI.funcName function\n' +
                '  alanBtnInstance.callProjectApi("script::funcName", {data:"your data"}, function(error, result){\n' +
                '    //handle error and result here\n' +
                '  });\n') +
            '\n' +
            '  //this is how you can play some text\n' +
            '  alanBtnInstance.playText("Hi");\n' +
            '\n' +
            '  //this is how you can send a command\n' +
            '  alanBtnInstance.playCommand({action:"openSomePage"});\n' +
            '\n' +
            '  //this is how you can turn on the Alan Button programmatically\n' +
            '  alanBtnInstance.activate().then(()=> {\n' +
            '      //this is how you can play some text\n' +
            '      alanBtnInstance.playText("Hi");\n' +
            '  });\n' +
            '\n' +
            '  //this is how you can turn off the Alan Button programmatically\n' +
            '  alanBtnInstance.deactivate();\n') +
        '</script>';
}
function getAllCode(key, alanLibUrl, codeMode) {
    return '<!DOCTYPE html>\n' +
        '<html lang="en">\n' +
        '<head>\n' +
        '<meta charset="UTF-8">\n' +
        '<title>Alan Example</title>\n' +
        '</head>\n' +
        '<body>\n' +
        '<div class="alan-btn"></div>\n' +
        '<script type="text/javascript"\n ' +
        `src="${alanLibUrl}"></script>\n` +
        '<script>\n' +
        '  var alanBtnInstance = alanBtn({\n' +
        '    key: "' + key + '\",\n' +
        '    host: "' + getHostUrlForIntegrations() + '\",\n' +
        (codeMode === 'simple' ? '' :
            '    authData: {data:"your auth data if needed"},\n') +
        '    onCommand: function (commandData) {\n' +
        '      if (commandData.command === "go:back") {\n' +
        '        //call client code that will react to the received command\n' +
        '      }\n' +
        '    },\n' +
        '    rootEl: document.getElementById("alan-btn"),\n' +
        '  });\n' +
        (codeMode === 'simple' ? '' :
            ('  //this is how you can set up a visual state\n' +
                '  alanBtnInstance.setVisualState({data:"your data"});\n' +
                '\n' +
                '  //this is how you can call projectAPI.funcName function\n' +
                '  alanBtnInstance.callProjectApi("script::funcName", {data:"your data"}, function(error, result){\n' +
                '    //handle error and result here\n' +
                '  });\n') +
            '\n' +
            '  //this is how you can play some text\n' +
            '  alanBtnInstance.playText("Hi");\n' +
            '\n' +
            '  //this is how you can send a command\n' +
            '  alanBtnInstance.playCommand({action:"openSomePage"});\n' +
            '\n' +
            '  //this is how you can turn on the Alan Button programmatically\n' +
            '  alanBtnInstance.activate();\n' +
            '\n' +
            '  //this is how you can turn off the Alan Button programmatically\n' +
            '  alanBtnInstance.deactivate();\n') +
        '</script>\n' +
        '</body>\n' +
        '</html>\n';
}

const htmlCodeMirrorOptions = {
    lineNumbers: false,
    readOnly: true,
    mode: { name: "htmlmixed" },
    scrollbarStyle: null,
    cursorScrollMargin: -1000,
};

const codeModes = [
    { name: 'Simple Example', key: 'simple' },
    { name: 'Advanced Example', key: 'advanced' }
];

export function WebTab({ alanKey }) {

    const alanLibUrl = `${getBaseUrl()}/web/lib/alan_lib.min.js`;

    const [codeMode, setCodeMode] = useState('simple');

    const changeCodeModeCb = useCallback((codeModeObj) => {
        setCodeMode(codeModeObj.key);
    }, []);

    return <div className="embed-code-tab">
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description">
            </div>
            <div className="embed-code-tab_dash"></div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_not-highlighted-code">
                    <Code>
                        {
                            '<!DOCTYPE html>\n' +
                            '<html lang="en">\n' +
                            '<head>\n' +
                            '  <meta charset="UTF-8">\n' +
                            '  <title>Alan Example</title>\n'
                        }
                    </Code>
                </div>
            </div>
            <div className="embed-code-tab_copy">
                <EmbedCodeCopyButton
                    text="Copy All"
                    code={getAllCode(alanKey, alanLibUrl, codeMode)} />
            </div>
        </div>
        <ComboBox values={codeModes}
            valueKey="key"
            valueName="name"
            classes="code-mode-combo-box light-blue-with-border"
            selectedValueId={codeMode}
            onValueSelect={changeCodeModeCb}
            renderItem={(codeModeItem) => {
                return <div style={{ paddingLeft: '8px' }}
                    key={codeModeItem.key}>
                    {codeModeItem.name}
                </div>;
            }} />

        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc2">
                Add a link to the font
            </div>
            <div className="embed-code-tab_dash embed-code-desc2">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="web" type="tag">
                        {googleFontCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={googleFontCode} />
                    </div>
                </div>
            </div>
        </div>

        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc2">
                Add a node that will be a container for the Alan btn
            </div>
            <div className="embed-code-tab_dash embed-code-desc2">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_not-highlighted-code">
                    <Code>
                        {'</head>'}
                        <br/>
                        {'<body>'}
                    </Code>
                </div>
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="web" type="tag">
                        {alanNodeCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={alanNodeCode} />
                    </div>
                </div>
            </div>
        </div>

        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc3">
                Handle commands from the Alan AI Studio
            </div>
            <div className="embed-code-tab_dash embed-code-desc3">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <ReactCodeMirror
                        value={getAlanScriptCode(alanKey, alanLibUrl, codeMode)}
                        options={htmlCodeMirrorOptions} />
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={getAlanScriptCode(alanKey, alanLibUrl, codeMode)} />
                    </div>
                </div>
                <div className="embed-code-tab_not-highlighted-code">
                    <Code>
                        {'</body>\n</html>'}
                    </Code>
                </div>
            </div>
        </div>
    </div>;
}
